import * as Sentry from '@sentry/react';
import { showToast } from 'src/components/toast';

export type LocationRetrieveFailure = 'request_failed' | 'no_coordinates';

/**
 * NPT-2196 — picking a suggestion that needs a retrieve (addresses, which Mapbox suggests without
 * coordinates) used to fail silently: the click did nothing and nothing reached Sentry. Report it
 * and tell the traveler. The id's length is logged, not the id itself: it encodes the address, and
 * its length is what broke the lookup last time (the API's 512 cap, the WAF's URI limit).
 */
export const reportLocationRetrieveFailure = (outcome: LocationRetrieveFailure, message: string, mapboxId: unknown, error?: unknown) => {
   Sentry.captureMessage('[location] Mapbox retrieve returned no usable location', {
      level: 'warning',
      tags: { feature: 'location-retrieve', location_retrieve_outcome: outcome },
      extra: {
         mapboxIdLength: typeof mapboxId === 'string' ? mapboxId.length : undefined,
         status: (error as { response?: { status?: number } })?.response?.status,
         reason: (error as Error)?.message,
      },
   });
   showToast('error', message);
};
